import { commonStyles, containerStyles, sectionStyles, tileStyles, } from "./shared.styles";
export const productComponentsSectionStyles = {
    // Re-export shared styles for easy access
    sectionHeader: sectionStyles.header,
    sectionHeaderComplete: sectionStyles.headerComplete,
    unifiedTile: tileStyles.unifiedTile,
    tileContainer: containerStyles.tileContainer,
    otherTileContent: tileStyles.otherTileContent,
    productTileContent: tileStyles.selectionTileContent,
    productIconContainer: tileStyles.selectionTileIconContainer,
    productIcon: tileStyles.selectionTileIcon,
    productImage: tileStyles.selectionTileImage,
    // Component-specific styles (using common styles)
    sectionContainer: commonStyles.sectionContainer,
    sectionTitle: commonStyles.sectionTitle,
    subsectionTitle: commonStyles.subsectionTitle,
    otherTextField: commonStyles.otherTextField,
    submitButton: commonStyles.submitButton,
    submitButtonContainer: commonStyles.submitButtonContainer,
};
